import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from '../../services/user.service';
import {SIDRUploaderDirective} from '../../components/helpers/fileupload/fileupload.directive';
import {DistrictService} from '../../services/district.service';
import {ActivatedRoute} from '@angular/router';
import {TitleService} from '../../services/title.service';
import {DistrictImportService} from '../../services/districtImport.service';
import {DistrictImportDto} from '@sidr/dto-types';


@Component({
  selector: `district-imports`,
  templateUrl: 'imports.component.html',
  styleUrls: ['imports.component.scss']
})
export class DistrictImportsComponent implements OnInit, OnDestroy {
  @ViewChild('sidrUploader') sidrUploader: SIDRUploaderDirective;
  districtId: string;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  imports: DistrictImportDto[];
  pageNumber = 0;
  totalImports = 0;
  pageSize = 20;
  intervalId: any;


  isDragOver: boolean = false;

  constructor(private userService: UserService,
              private activeRoute: ActivatedRoute,
              private titleService: TitleService,
              private districtService: DistrictService,
              private importService: DistrictImportService) {
  }

  onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }
  onDragOver(event: DragEvent) {
    event.preventDefault(); // required to allow drop
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    this.isDragOver = false;
    // existing drop handling can proceed here (or let your uploader component handle it)
  }


  public ngOnInit() {
    this.activeRoute?.parent?.params.subscribe(p => {
      this.districtId = p['districtId'];
      this.getData();
    });

    this.importService.fileUploaded.subscribe(f => {
      this.getData();
    });

    this.titleService.setTitle('District Imports');
    this.intervalId = setInterval(() => this.getData(), 5000);
  }

  public ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getData() {
    if (!this.districtId) {
      return;
    }
    this.districtService.getImports(this.districtId, this.pageNumber, this.pageSize).subscribe(imports => {
      this.imports = imports || [];
    });
    this.districtService.getImportCount(this.districtId).subscribe(count => {
      this.totalImports = count;
    });
  }

  get totalPages(): number {
    return Math.ceil(this.totalImports / this.pageSize);
  }

  goToFirstPage() {
    this.pageNumber = 0;
    this.getData();
  }

  prevPage() {
    if (this.pageNumber > 0) {
      this.pageNumber--;
      this.getData();
    }
  }

  nextPage() {
    if ((this.pageNumber + 1) * this.pageSize < this.totalImports) {
      this.pageNumber++;
      this.getData();
    }
  }

  goToLastPage() {
    this.pageNumber = this.totalPages - 1;
    this.getData();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }


  onFilesChangedEmitter($event: FileList) {
    const files: File[] = [];
    for (let i = 0; i < $event.length; i++) {
      const file = $event.item(i);
      if (file) {
        files.push(file);
      }
    }
    this.importService.uploadFiles(this.districtId, files);
  }
}
